import React, { useState } from 'react'

import { Box, Icon, Tag, Text, Tooltip } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { categoryTimeTypeTag } from 'modules/attendance/components/CustomTimeRanges/Content/utils/categoryNameWithTimeTypeLabel'
import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

interface TagsContentProps {
  dateRange: string | null
  range: CustomTimeRange
}

const tooltipIcon = (range: CustomTimeRange): React.ComponentProps<typeof Icon.Medium>['icon'] => {
  switch (range.poolType) {
    case 'virtual_timeoff': {
      return 'clock'
    }
    case 'virtual_payroll': {
      return 'money-bag'
    }
    default: {
      return 'balance'
    }
  }
}

const tooltipLabel = (range: CustomTimeRange): string => {
  switch (range.poolType) {
    case 'virtual_timeoff': {
      return i18n.t('time_tracking.settings.custom_time_range_section.timeoff_tooltip')
    }
    case 'virtual_payroll': {
      return i18n.t('time_tracking.settings.custom_time_range_section.payroll_tooltip')
    }
    default: {
      return i18n.t('time_tracking.settings.custom_time_range_section.balance_tooltip')
    }
  }
}

const TagsContent = ({ dateRange, range }: TagsContentProps) => {
  const [iconHover, setIconHover] = useState<boolean>(false)
  const iconHoverLabel = tooltipLabel(range)

  return (
    <>
      {dateRange && (
        <Text.Normal size="100" weight="medium">
          {dateRange}
        </Text.Normal>
      )}

      <Box key={range.id} maxWidth="full" flexDirection="row" gap="s2">
        <Tag type={categoryTimeTypeTag(range.timeType)}>{range.name}</Tag>
        {!range.isRegular && (
          <Box onMouseEnter={() => setIconHover(true)} onMouseLeave={() => setIconHover(false)}>
            <Tooltip.Alt attachment="bottom center" label={iconHoverLabel} open={iconHover}>
              <Icon.Medium icon={tooltipIcon(range)} color="grey800" />
            </Tooltip.Alt>
          </Box>
        )}
      </Box>
    </>
  )
}

export default TagsContent
